<template>
  <div
    class="question-completed primary-block text-center pt-5 pb-5"
    v-if="Object.keys(texts).length > 0"
  >
    <svg
      class="mb-4 mb-md-5"
      width="86"
      height="86"
      viewBox="0 0 86 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M21 40.5L37.5 57L65.5 29" stroke="black" stroke-width="2" />
      <circle cx="43" cy="43" r="42" stroke="black" stroke-width="2" />
    </svg>
    <h1 class="mb-4 mb-md-5">{{ texts.doneText }}</h1>
    <p class="mb-5">{{ texts.doneLongerText }}</p>
    <div
      style="max-width: 400px; margin: 0 auto;"
      class="d-flex flex-column mb-4 mb-md-5 pl-0 pr-0 pl-md-4 pr-md-4"
    >
      <a @click="pushHash('signin')" class="btn btn-primary btn-lg mb-3 w-100 force-color-white">{{
        texts.signInText
      }}</a>
      <a @click="pushHash('signup')" class="btn btn-secondary btn-lg w-100">{{
        texts.createAccountText
      }}</a>
    </div>
    <small class="text-gray">{{ texts.recommendationBasedOn }}</small>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.query.id,
      texts: {},
    };
  },
  methods: {
    returnCorrectLangDomain() {
      const { lang } = this.$route.query;
      if (lang.toLowerCase() === 'no') return 'https://www.bangerhead.no';
      if (lang.toLowerCase() === 'fi') return 'https://www.bangerhead.fi';
      if (lang.toLowerCase() === 'dk') return 'https://www.bangerhead.dk';
      return 'https://www.bangerhead.se/';
    },
    pushHash(hash) {
      window.parent.postMessage(hash, this.returnCorrectLangDomain());
    },
  },
  mounted() {
    const { lang } = this.$route.query;
    this.$http
      .get(`/api/translations/?lang=${lang || 'sv'}`)
      .then(r => r.data)
      .then((r) => {
        this.texts = r;
      });
  },
};
</script>
